/**
 * Утилиты раздела «Нормоконтроль» (НК-2a-2).
 *
 * Бэкенд возвращает фрагмент поиска по пунктам с маркерами подсветки в частных
 * символах Unicode ( — начало,  — конец совпадения; см.
 * backend/app/api/norms.py). Текст — внешние данные (норматив), поэтому сначала
 * экранируем HTML, и только потом заменяем парные маркеры на <mark>. Одиночные
 * маркеры (обрезанный фрагмент) выбрасываем.
 */

export const HL_START = '';
export const HL_STOP = '';

function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** Фрагмент с маркерами подсветки → безопасный HTML с <mark>. */
export function highlightFragment(fragment) {
  const esc = escapeHtml(fragment);
  const re = new RegExp(HL_START + '([\\s\\S]*?)' + HL_STOP, 'g');
  return esc
    .replace(re, '<mark>$1</mark>')
    .split(HL_START).join('')
    .split(HL_STOP).join('');
}
